import { useTranslation } from 'react-i18next';

import { GetInvitationQuery as GetInvitation } from '__generated__/graphql';

import { CopyLinkInput } from '../../../../common/Common/CopyLink';
import UI from '../../../../common/UI';
import useLocale from '../../../../common/useLocale';

type Invitation = GetInvitation['invitation'];

interface ShareInfoProps {
  invitation: Invitation;
}

const ShareInfo = ({ invitation }: ShareInfoProps) => {
  const { t } = useTranslation();
  const { formatInteger } = useLocale();

  return (
    <UI.FormGrid>
      <UI.Div>
        <UI.Legend sc={{ mb: 1 }}>
          {t('share_invitation')}
        </UI.Legend>
        <UI.InputDescription>
          {invitation.has_unique_codes
            ? t('share_invitation_codes_description') : t('share_invitation_code_description')}
        </UI.InputDescription>
      </UI.Div>

      {invitation.has_unique_codes && (
        <>
          <UI.Div>
            <UI.Label sc={{ strong: true }}>
              {invitation.example.value}
            </UI.Label>
            {invitation.max_uses > 1 && (` ${t('and_n_more', {
              n: formatInteger(invitation.max_uses - 1),
              count: invitation.max_uses - 1,
            })}`)}
          </UI.Div>
          <UI.Div>
            <UI.AButton
              href={invitation.download_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('download_invitation_codes')}
            </UI.AButton>
          </UI.Div>
        </>
      )}

      {!invitation.has_unique_codes && (
        <UI.Div>
          <UI.InputLabel>
            {t('registration_link')}
          </UI.InputLabel>
          {(invitation.max_uses === null || invitation.max_uses > 1) && (
            <UI.InputDescription>
              {t('share_invitation_unique_codes_tip')}
            </UI.InputDescription>
          )}
          <CopyLinkInput value={invitation.code.registration_url} />
        </UI.Div>
      )}
    </UI.FormGrid>
  );
};

export default ShareInfo;
